import { createStore, compose } from 'redux';
import {rootReducer} from './rootReducer';
import createMiddleware, { sagaMiddleware } from './middleware'
import sharedSagas from './Shared/sagas';
import notificationSagas from './Notifications/sagas';
import librarySagas from './Library/saga';
import performanceReportSagas from './PerformanceReport/saga';
import adminSagas from './Admin/saga';
import dealerSagas from './Dealers/saga';

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, composeEnhancers(createMiddleware()));
sagaMiddleware.run(sharedSagas);
sagaMiddleware.run(notificationSagas);
sagaMiddleware.run(librarySagas);
sagaMiddleware.run(performanceReportSagas);
sagaMiddleware.run(adminSagas);
sagaMiddleware.run(dealerSagas);
export default store;
